module.exports = __webpack_public_path__ + "img/fund_img2.5a44949e.png";